const pdpCTA = document.querySelector(".product-detail-page__section-select");
//Fixed position bar
if(pdpCTA) {
  const offset = pdpCTA.offsetTop;
  const rect   = pdpCTA.getBoundingClientRect();
  const scrollUp = "scroll-up";
  const scrollDown = "scroll-down";
  let lastScroll = 0;
  // Create the function to be called on scroll
  const stick = function () {

    // Get the scroll
    let scroll = window.scrollY;
    if ( scroll >= offset) {
        pdpCTA.classList.add('stick');
    } else if (scroll <= offset){
        pdpCTA.classList.remove('stick');
    }
    
    if (scroll <= offset) {
        pdpCTA.classList.remove(scrollUp);
        pdpCTA.classList.remove(scrollDown);
      return;
    }
    
    if (scroll > lastScroll && !pdpCTA.classList.contains(scrollDown)) {
      // down
      pdpCTA.classList.remove(scrollUp);
      pdpCTA.classList.add(scrollDown);
    } else if (scroll < lastScroll && pdpCTA.classList.contains(scrollDown)) {
      // up
      pdpCTA.classList.remove(scrollDown);
      pdpCTA.classList.add(scrollUp);
    }
    lastScroll = scroll;
  };
  // listen to the scroll
  window.addEventListener('scroll', stick);
}

//Scroll the section into view with the same id as link href
const sectionAnchorsContainer = document.querySelector('.product-detail-page__section-anchors');
if(sectionAnchorsContainer) {
    const sectionAnchors = sectionAnchorsContainer.querySelectorAll('a');
    sectionAnchors.forEach(function(anchor) {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            //Remove the active class from all li's
            const sectionAnchorItems = sectionAnchorsContainer.querySelectorAll('li');
            sectionAnchorItems.forEach(function(item) {
              item.classList.remove('active');
            });
            //Add active class to the clicked a tag parent li
            anchor.parentNode.classList.add('active');
            //Get the href of the click a tag minus the hash character
            const link = anchor.getAttribute('href').substr(1);
            const section = document.getElementById(link);
            const header = section.querySelector('h2');
            header.scrollIntoView({behavior:'smooth'});
         });
    });
}
